import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../utils/apiClient";
import IngredientListGrouped from "../components/IngredientListGrouped"

export default function MealPlanShoppingList() {
  const { id } = useParams();
  const [mealPlan, setMealPlan] = useState(null);
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("all");
  const [checked, setChecked] = useState({});

  useEffect(() => {
    apiClient.get(`/mealplans/${id}`).then(res => {
      const plan = res.data;
      setMealPlan(plan);

      const combinedList = [];
      const initialChecked = {};

      plan.recipes.forEach((recipe, recipeIndex) => {
        recipe.ingredients.forEach((ingredient, idx) => {
          const key = `${recipe._id}-${idx}`;
          combinedList.push({
            recipeName: recipe.name,
            recipeId: recipe._id,
            isHeading: ingredient.isHeading,
            ingredient: ingredient.text,
            key,
          });
          initialChecked[key] = false;
        });
      });

      setList(combinedList);
      setChecked(initialChecked);
    });
  }, [id]);

  const toggle = (key) => {
    setChecked(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  if (!mealPlan) return <p className="text-center mt-10">Loading Shopping List...</p>;

  return (
    <div className="max-w-3xl mt-10 mx-auto px-4 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">{mealPlan.name} – Shopping List</h1>
      </div>
      <IngredientListGrouped recipes={mealPlan.recipes} />
    </div>
  );
}
